import React, { useState } from 'react';

const HudCard = () => {
  const [currentScreen, setCurrentScreen] = useState(0);

  const hudScreens = [
    {
      id: 'launcher',
      title: 'App Launcher',
      description: 'Main menu với các app icons',
      content: (
        <div className="hud-content">
          <div className="status-bar">
            <div className="status-item">
              <span className="material-icons">wifi</span>
              <span>ESP32</span>
            </div>
            <div className="status-item">
              <span className="material-icons">battery_full</span>
              <span>98%</span>
            </div>
            <div className="status-time">14:23</div>
          </div>
          
          <div className="app-launcher">
            <div className="app-grid">
              <div className="app-icon">
                <span className="material-icons">navigation</span>
                <span className="app-label">Chỉ đường</span>
              </div>
              <div className="app-icon">
                <span className="material-icons">wb_sunny</span>
                <span className="app-label">Thời tiết</span>
              </div>
              <div className="app-icon">
                <span className="material-icons">settings</span>
                <span className="app-label">Cài đặt</span>
              </div>
              <div className="app-icon">
                <span className="material-icons">notifications</span>
                <span className="app-label">Thông báo</span>
              </div>
              <div className="app-icon">
                <span className="material-icons">music_note</span>
                <span className="app-label">Nhạc</span>
              </div>
              <div className="app-icon">
                <span className="material-icons">more_horiz</span>
                <span className="app-label">Khác</span>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'navigation',
      title: 'Chỉ đường',
      description: 'GPS navigation với hướng dẫn',
      content: (
        <div className="hud-content">
          <div className="status-bar">
            <div className="status-item">
              <span className="material-icons">gps_fixed</span>
              <span>GPS</span>
            </div>
            <div className="status-item">
              <span className="material-icons">battery_full</span>
              <span>94%</span>
            </div>
            <div className="status-time">14:25</div>
          </div>
          
          <div className="navigation-screen">
            <div className="nav-main">
              <div className="nav-direction">
                <span className="material-icons nav-arrow">turn_right</span>
                <div className="nav-text">
                  <div className="nav-instruction">Rẽ phải</div>
                  <div className="nav-distance">sau 200m</div>
                </div>
              </div>
            </div>
            
            <div className="nav-info-grid">
              <div className="nav-info-item">
                <span className="material-icons">straighten</span>
                <div className="nav-info-text">
                  <span className="nav-label">Còn lại</span>
                  <span className="nav-value">2.5km</span>
                </div>
              </div>
              <div className="nav-info-item">
                <span className="material-icons">schedule</span>
                <div className="nav-info-text">
                  <span className="nav-label">Thời gian</span>
                  <span className="nav-value">8 phút</span>
                </div>
              </div>
              <div className="nav-info-item">
                <span className="material-icons">speed</span>
                <div className="nav-info-text">
                  <span className="nav-label">Tốc độ</span>
                  <span className="nav-value">45km/h</span>
                </div>
              </div>
              <div className="nav-info-item">
                <span className="material-icons">place</span>
                <div className="nav-info-text">
                  <span className="nav-label">Đích đến</span>
                  <span className="nav-value">Quận 1</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'weather',
      title: 'Thời tiết',
      description: 'Thông tin thời tiết hiện tại',
      content: (
        <div className="hud-content">
          <div className="status-bar">
            <div className="status-item">
              <span className="material-icons">wifi</span>
              <span>ESP32</span>
            </div>
            <div className="status-item">
              <span className="material-icons">battery_full</span>
              <span>96%</span>
            </div>
            <div className="status-time">14:27</div>
          </div>
          
          <div className="weather-screen">
            <div className="weather-main">
              <div className="weather-display">
                <span className="material-icons weather-icon">wb_sunny</span>
                <div className="temp-info">
                  <div className="temperature">28°C</div>
                  <div className="weather-desc">Nắng đẹp</div>
                </div>
              </div>
            </div>
            
            <div className="weather-details">
              <div className="weather-item">
                <span className="material-icons">water_drop</span>
                <div className="weather-text">
                  <span className="weather-label">Độ ẩm</span>
                  <span className="weather-value">65%</span>
                </div>
              </div>
              <div className="weather-item">
                <span className="material-icons">air</span>
                <div className="weather-text">
                  <span className="weather-label">Gió</span>
                  <span className="weather-value">12km/h</span>
                </div>
              </div>
              <div className="weather-item">
                <span className="material-icons">visibility</span>
                <div className="weather-text">
                  <span className="weather-label">Tầm nhìn</span>
                  <span className="weather-value">10km</span>
                </div>
              </div>
              <div className="weather-item">
                <span className="material-icons">compress</span>
                <div className="weather-text">
                  <span className="weather-label">Áp suất</span>
                  <span className="weather-value">1013hPa</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'settings',
      title: 'Cài đặt',
      description: 'Cấu hình hệ thống',
      content: (
        <div className="hud-content">
          <div className="status-bar">
            <div className="status-item">
              <span className="material-icons">wifi</span>
              <span>ESP32</span>
            </div>
            <div className="status-item">
              <span className="material-icons">battery_full</span>
              <span>92%</span>
            </div>
            <div className="status-time">14:29</div>
          </div>
          
          <div className="settings-screen">
            <div className="settings-list">
              <div className="setting-item">
                <span className="material-icons">brightness_6</span>
                <div className="setting-text">
                  <span className="setting-label">Độ sáng màn hình</span>
                  <span className="setting-value">80%</span>
                </div>
              </div>
              <div className="setting-item">
                <span className="material-icons">volume_up</span>
                <div className="setting-text">
                  <span className="setting-label">Âm lượng</span>
                  <span className="setting-value">60%</span>
                </div>
              </div>
              <div className="setting-item">
                <span className="material-icons">wifi</span>
                <div className="setting-text">
                  <span className="setting-label">WiFi</span>
                  <span className="setting-value">Kết nối</span>
                </div>
              </div>
              <div className="setting-item">
                <span className="material-icons">bluetooth</span>
                <div className="setting-text">
                  <span className="setting-label">Bluetooth</span>
                  <span className="setting-value">Tắt</span>
                </div>
              </div>
              <div className="setting-item">
                <span className="material-icons">power_settings_new</span>
                <div className="setting-text">
                  <span className="setting-label">Chế độ tiết kiệm</span>
                  <span className="setting-value">Bật</span>
                </div>
              </div>
              <div className="setting-item">
                <span className="material-icons">update</span>
                <div className="setting-text">
                  <span className="setting-label">Phiên bản</span>
                  <span className="setting-value">v2.1.0</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 'dashboard',
      title: 'Dashboard',
      description: 'Bảng điều khiển xe máy',
      content: (
        <div className="hud-content">
          <div className="status-bar">
            <div className="status-item">
              <span className="material-icons">two_wheeler</span>
              <span>READY</span>
            </div>
            <div className="status-item">
              <span className="material-icons">battery_full</span>
              <span>89%</span>
            </div>
            <div className="status-time">14:31</div>
          </div>
          
          <div className="dashboard-screen">
            <div className="dashboard-main">
              <div className="speed-display">
                <div className="speed-value">45</div>
                <div className="speed-unit">KM/H</div>
              </div>
              <div className="rpm-display">
                <div className="rpm-value">3500</div>
                <div className="rpm-unit">RPM</div>
              </div>
            </div>
            
            <div className="dashboard-info">
              <div className="info-item">
                <span className="material-icons">local_gas_station</span>
                <span className="info-label">Xăng</span>
                <span className="info-value">85%</span>
              </div>
              <div className="info-item">
                <span className="material-icons">thermostat</span>
                <span className="info-label">Nhiệt độ</span>
                <span className="info-value">82°C</span>
              </div>
              <div className="info-item">
                <span className="material-icons">tire_repair</span>
                <span className="info-label">Lốp trước</span>
                <span className="info-value">2.1bar</span>
              </div>
              <div className="info-item warning-item">
                <span className="material-icons">tire_repair</span>
                <span className="info-label">Lốp sau</span>
                <span className="info-value warning">1.5bar</span>
              </div>
            </div>
          </div>
        </div>
      )
    }
  ];

  const nextScreen = () => {
    setCurrentScreen((prev) => (prev + 1) % hudScreens.length);
  };

  const prevScreen = () => {
    setCurrentScreen((prev) => (prev - 1 + hudScreens.length) % hudScreens.length);
  };

  return (
    <section className="projects" id="projects">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">HUD Screens Preview</h2>
          <p className="section-description">
            Khám phá các màn hình khác nhau của HUD system. **Các tính năng, giao diện có thể khác với sản phẩm thực tế, tuy nhiên uProject sẽ cố gắng cập nhật trong tương lai với thiết kế tương tự
          </p>
        </div>

        <div className="hud-gallery">
          <button className="gallery-nav gallery-prev" onClick={prevScreen}>
            <span className="material-icons">chevron_left</span>
          </button>

          <div className="hud-preview-container">
            <div className="screen-info">
              <h3 className="screen-title">{hudScreens[currentScreen].title}</h3>
              <p className="screen-description">{hudScreens[currentScreen].description}</p>
            </div>
            
            <div className="hud-card glass" key={hudScreens[currentScreen].id}>
              <div className="hud-display">
                {hudScreens[currentScreen].content}
              </div>
            </div>
          </div>

          <button className="gallery-nav gallery-next" onClick={nextScreen}>
            <span className="material-icons">chevron_right</span>
          </button>
        </div>

        <div className="screen-indicators">
          {hudScreens.map((screen, index) => (
            <button
              key={screen.id}
              className={`indicator ${index === currentScreen ? 'active' : ''}`}
              onClick={() => setCurrentScreen(index)}
            >
              <span className="indicator-label">{screen.title}</span>
            </button>
          ))}
        </div>

        <div className="project-description">
          <p>
            HUD launcher đơn giản cho ESP32-S3. Hiển thị status bar với pin, giờ, 
            và nhiều screens khác nhau: launcher, navigation, weather, settings. 
            Giao diện tối giản dễ sử dụng.
          </p>
        </div>
      </div>
    </section>
  );
};

export default HudCard;
